/**
 * add query to url
 * @param {*} url
 * @param {*} query
 */
export const addQueryToUrl = (url, query = {}) => {
  const queryKeys = Object.keys(query);
  if (queryKeys.length <= 0 || !url) return url;
  const inputUrl = new URL(url);
  const inputParams = new URLSearchParams(inputUrl.search);
  queryKeys.forEach(k => inputParams.append(k, query[k]));
  return `${inputUrl.origin}${inputUrl.pathname}?${inputParams.toString()}`;
};
/**
 * transfer object to query parameters
 * @param {*} obj
 */
export const objToQueryString = obj => {
  return Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&');
};
